export default __webpack_public_path__ + "static/media/outside.e0835202.png";